// Utils
import predicates from '../../../../common/utils/lib/predicates';

export default (predicateArray = []) => {
    const runPredicates = predicates(predicateArray);
    return (props, monitor) => runPredicates({ props, monitor });
};
